import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'

import './VerifyEmail.scss'
import * as Router from '../../../shared/router'
import branding from '../../../shared/branding'

import Spinner from '../../../components/Loader/Spinner/Spinner'
import { useQuery } from '../../../shared/utility'
import { VerifyEmailAPI } from '../../../api/User/VerifyEmail'
import FormHandler from '../../../factory/FormHandler'
import toastCenter, { toastMessageType } from '../../../shared/toastCenter'
import LogoLogin from '../Logo.png'
import { RequestEmailVerificationAPI } from '../../../api/User/RequestEmailVerification'
import { UserRequestEmailVerificationAPI } from '../../../api/User/UserRequestEmailVerification'
import hero1 from '../hero.jpg'
// import SvgCheckSuccess from '../../../Icons/CheckSuccess'

function VerifyEmail({ history }) {
  let query = useQuery()
  let token = query.get('key')
  let userType = query.get('user') ? query.get('user') : 'customer'
  let email = query.get('email')
  let loginPage = userType === 'customer' ? Router.signin : Router.signinAdmin
  const localToken = localStorage.getItem('token')

  const [pageLoading, setPageLoading] = useState(true)
  const [emailVerified, setEmailVerified] = useState(false)

  useEffect(() => {
    const verifyEmailAPI = new VerifyEmailAPI()

    if (token && userType && email) {
      const data = new FormHandler()
      data.append('token', token)
      data.append('user', userType)
      data.append('email', email)

      const onNext = (response) => {
        if (response.success) {
          setEmailVerified(true)
          setPageLoading(false)
        } else {
          let message = response.messages
            ? response.messages
            : response.message
            ? response.message
            : 'Someting went wrong'
          toastCenter.message('Failed', message, toastMessageType.ERROR)
          if (response.data && response.data.action === 'token_expired') {
            setPageLoading(false)
          } else {
            setTimeout(() => {
              history.push(loginPage)
            }, 5000)
          }
        }
      }
      const onComplete = () => {}
      const onError = () => {
        toastCenter.messageServerError()
      }
      verifyEmailAPI.subscribe(data.all(), onNext, onComplete, onError)
    } else {
      history.push(loginPage)
    }

    return () => {
      verifyEmailAPI.unsubscribe()
    }
  }, [history, token, userType, email, loginPage])

  const resendEmailVerification = () => {
    if (userType && email) {
      const requestEmailVerification =
        userType === 'user'
          ? new UserRequestEmailVerificationAPI()
          : new RequestEmailVerificationAPI()
      const data = new FormHandler()
      data.append('token', token)
      data.append('userType', userType)
      data.append('email', email)

      const onNext = (response) => {
        if (response.success) {
          toastCenter.message(
            'Success',
            `An email has been sent to ${email} with a link to verify your account.`,
            toastMessageType.SUCCESS
          )
        } else {
          let message = response.messages
            ? response.messages
            : response.message
            ? response.message
            : 'Someting went wrong'
          toastCenter.message('Failed', message, toastMessageType.ERROR)
        }
      }
      const onComplete = () => {}
      const onError = () => {
        toastCenter.messageServerError()
      }
      requestEmailVerification.subscribe(
        localToken !== null,
        data.all(),
        onNext,
        onComplete,
        onError
      )
    }
  }

  return (
    <div className="verify-email-wrapper h-100 overflow-hidden">
      <Helmet>
        <title>{branding.NAME} - Verify Email</title>
      </Helmet>

      {pageLoading ? (
        <Spinner isLoading={true} />
      ) : (
        <>
          <div className="header">
            <div className="container-fluid container-custom position-relative h-100">
              <div className="row">
                <div className="col-md-6 pr-5 left">
                  <div className="d-flex">
                    <div className="flex-fill logo d-flex align-items-center">
                      {branding.NAME === 'ngine' && (
                        <a
                          href={branding.DOMAIN}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={LogoLogin} className="logo" alt="" />
                        </a>
                      )}
                    </div>

                    {/* {branding.NAME === 'ngine' && (
                                          <div className="flex-fill d-flex flex-row justify-content-end align-items-center ml-auto nav-item">
                                            <span className="nobreak d-md-inline  d-sm-inline  d-md-inline  d-lg-inline  d-xl-inline">
                                              Want an account?
                                            </span>
                                            <a
                                              className="btn btn-lg btn-link btn-register ml-1"
                                              href={branding.REGISTER}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              Start Free Trial
                                            </a>
                                          </div>
                                        )} */}
                  </div>
                </div>

                <div className="col-6 col-sm-6">&nbsp;</div>
              </div>
            </div>
          </div>

          <div className="form-signin">
            <div className="container-fluid position-relative">
              <div className="row d-flex h-100 align-items-end z-1 position-relative flex-row justify-content-end justify-content-md-start">
                <div className="col-12 order-2 order-sm-1 col-sm-6 section-content">
                  {emailVerified ? (
                    <>
                      {/* <div className="email-verification-container fade show visible"> */}
                      {/* <SvgCheckSuccess /> */}
                      <h1 className="mt-5">Thank you!</h1>
                      <p>
                        You have successfully verified your account. Now you can
                        log in to your dashboard and make your first order.
                      </p>
                      <a
                        href={loginPage}
                        className="btn btn-darkprimary btn-block rounded-pill btn-login d-flex align-items-center justify-content-center"
                      >
                        Log in to dashboard
                      </a>
                      {/* </div> */}
                    </>
                  ) : (
                    <>
                      {/* <div className="email-verification-container fade show visible"> */}
                      <h1>Failed!</h1>
                      <p>
                        Email verification token is expired. Please retry
                        verification process by clicking the button below.
                      </p>
                      <button
                        className="btn btn-lg btn-darkprimary rounded-pill btn-login"
                        onClick={resendEmailVerification}
                      >
                        Resend Email Verification
                      </button>
                      {/* </div> */}
                    </>
                  )}
                </div>

                <div className="col-6 order-1 order-sm-2 col-sm-6 section-img px-0">
                  <img src={hero1} alt="" />
                </div>
              </div>
            </div>
          </div>

          <footer className="footer py-3">
            <div className="container-fluid container-custom">
              <div className="row">
                <div className="col-lg-12 col-sm-12">
                  <div className="align-items-center copyright">
                    {branding.NAME === 'Smart' && (
                      <span>
                        Copyright © 2024 <i>Smart!</i>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </>
      )}
    </div>
  )
}

export default withRouter(VerifyEmail)
